import { createContext, useContext } from 'react';

const _HapticsContext = createContext(null);
/**
 * Provide a haptics implementation down to all FPL components.
 */
const HapticsContext = _HapticsContext.Provider;
/** Get the haptics implementation passed in via FplSettings.HapticsContext. */
function useHaptics() {
    return useContext(_HapticsContext);
}

export { HapticsContext, useHaptics };
//# sourceMappingURL=settings.haptics.js.map
